export default "__VITE_ASSET__DlqyD5QN__"